import { useMemo } from 'react';

export const useCombinedLoading = (...values: boolean[]) => {
  const loading = useMemo(() => values.some((v) => v), values);
  return loading;
};
